import {
  FC, memo, useCallback, useEffect,
} from 'react';
import {
  Modal,
} from 'shared/ui';
import { engineActions } from 'entities/engine';
import { useAppDispatch } from 'app/providers/Store';
import { useEngines } from '../../hooks/useEngines';
import { EngineMainInfoSection } from './EngineMainInfoSection';
import { EngineReportSection } from './EngineReportSection';
import { EngineOrdersSection } from './EngineOrdersSection';
import { EngineUnFormalizedZipSection } from './EngineUnFormalizedZipSection';
import { EngineMeasurementSection } from './EngineMeasurementSection';
import styles from './EngineDetailModal.module.scss';

interface EngineDetailModalProps {
  engineId: number | null;
  onClose: () => void;
}

export const EngineDetailModal: FC<EngineDetailModalProps> = memo(({
  engineId,
  onClose,
}) => {
  const { loadEngineDetail, engineDetail } = useEngines();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (engineId) {
      loadEngineDetail(engineId);
    }
    return () => {
      dispatch(engineActions.dropDetailData());
    };
  }, [engineId]);

  const handleReportUploaded = useCallback(() => {
    if (engineId) {
      loadEngineDetail(engineId);
    }
  }, [engineId, loadEngineDetail]);

  return (
    <Modal
      title="Информация о машине"
      open={!!engineDetail?.id}
      onCancel={onClose}
      footer={[
        <div key="footer" className={styles.modalFooter}>
          <button type="button" className={styles.closeButton} onClick={onClose}>
            Закрыть
          </button>
        </div>,
      ]}
      width={1400}
      destroyOnClose
    >
      <div className={styles.modalContent}>
        {engineDetail && (
          <div className={styles.engineDetails}>
            {/* Основная информация */}
            <EngineMainInfoSection engineDetail={engineDetail} />

            {/* Отчёты по инспекциям */}
            <EngineReportSection
              engineId={engineId}
              reportUuids={engineDetail.reportUuids}
              onUploaded={handleReportUploaded}
            />

            {/* Измерения */}
            <EngineMeasurementSection
              engineId={engineId}
            />

            {/* Заявки */}
            <EngineOrdersSection
              engineId={engineId}
            />

            {/* Неформализованные ЗИП */}
            <EngineUnFormalizedZipSection
              engineId={engineId}
            />
          </div>
        )}
      </div>
    </Modal>
  );
});

EngineDetailModal.displayName = 'EngineDetailModal';
